import axios from "axios";

export default axios.create({
  baseURL: "https://monosindico.com.br/api",
});
